// Region-level content templates for city landing pages.
// City pages pull from these instead of hand-written per-city copy so that
// facts (cost ranges, seasonal advice) stay accurate at scale without
// producing near-duplicate "doorway page" content across hundreds of cities.
const regions = {
    southeast: {
        label: 'the Southeast',
        climateNote: 'humid summers, mild winters, and heavy spring pollen',
        hvacCostRange: '$5,000–$12,000',
        waterHeaterCostRange: '$1,200–$2,500',
        seasonalAdvice: 'pre-summer HVAC servicing, gutter cleaning ahead of storm season, and regular exterior inspections to catch humidity-driven wood rot early',
        commonNeeds: ['HVAC servicing', 'Gutter cleaning', 'Roof & exterior inspections', 'Pest prevention'],
    },
    northeast: {
        label: 'the Northeast',
        climateNote: 'cold, snowy winters and humid summers',
        hvacCostRange: '$6,000–$14,000',
        waterHeaterCostRange: '$1,400–$2,800',
        seasonalAdvice: 'winterizing exterior plumbing before the first freeze, furnace/boiler tune-ups each fall, and roof inspections after heavy snow loads',
        commonNeeds: ['Furnace & boiler tune-ups', 'Pipe winterization', 'Roof snow-load inspections', 'Basement waterproofing'],
    },
    midwest: {
        label: 'the Midwest',
        climateNote: 'wide temperature swings between hot summers and freezing winters',
        hvacCostRange: '$5,500–$13,000',
        waterHeaterCostRange: '$1,300–$2,600',
        seasonalAdvice: 'furnace inspections before winter, sump pump checks ahead of spring thaw, and sealing drafts as temperatures swing',
        commonNeeds: ['Furnace inspections', 'Sump pump maintenance', 'Window & door draft sealing', 'Gutter cleaning'],
    },
    southwest: {
        label: 'the Southwest',
        climateNote: 'intense summer heat and low humidity',
        hvacCostRange: '$5,000–$11,500',
        waterHeaterCostRange: '$1,100–$2,300',
        seasonalAdvice: 'pre-summer AC servicing, irrigation and foundation checks in dry soil conditions, and roof inspections for sun/UV wear',
        commonNeeds: ['AC servicing', 'Foundation monitoring', 'Roof UV-wear inspection', 'Irrigation system checks'],
    },
    west: {
        label: 'the West',
        climateNote: 'mild, dry summers and wet winters',
        hvacCostRange: '$5,500–$13,500',
        waterHeaterCostRange: '$1,300–$2,700',
        seasonalAdvice: 'roof and gutter checks before the rainy season, wildfire-defensible landscaping upkeep, and seismic bracing checks for water heaters',
        commonNeeds: ['Roof & gutter inspections', 'Water heater seismic bracing', 'Defensible-space landscaping', 'Drainage checks'],
    },
};

export default regions;
